import { $axios, apiList } from '@/api'

export default {
    actions: {
        deleteComment(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.comments.deleteComment.method,
                    params: {
                        wsfunction: apiList.comments.deleteComment.moodle_method,
                        comments: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
